
import { ApiPropertyOptional } from '@nestjs/swagger'
import {
  IsEnum,
  IsOptional,
  IsString,
  IsUUID,
  IsArray,
  IsInt,
  Min,
  Max,
} from 'class-validator'
import { Transform, Type } from 'class-transformer'
import { OffsetPaginationQueryDto } from '@sphere/shared/domain'

/**
 * Portée de visibilité pour la bibliothèque
 */
export enum LibraryScope {
  /** Contenu public uniquement */
  PUBLIC = 'PUBLIC',
  /** Contenu de l'établissement uniquement */
  ESTABLISHMENT = 'ESTABLISHMENT',
  /** Les deux : public + établissement */
  BOTH = 'BOTH',
}

/**
 * Type de contenu pédagogique
 */
export enum LibraryContentType {
  CHAPTER = 'chapter',
  LESSON = 'lesson',
  RESOURCE = 'resource',
}

/**
 * DTO pour requêtes de bibliothèque
 */
export class LibraryQueryDto extends OffsetPaginationQueryDto {
  @ApiPropertyOptional({
    description: 'Portée de la recherche (PUBLIC, ESTABLISHMENT, BOTH)',
    enum: LibraryScope,
    default: LibraryScope.BOTH,
  })
  @IsOptional()
  @IsEnum(LibraryScope)
  scope?: LibraryScope = LibraryScope.BOTH

  @ApiPropertyOptional({
    description: 'Types de contenus à inclure',
    enum: LibraryContentType,
    isArray: true,
  })
  @IsOptional()
  @Transform(({ value }: { value: string | string[] }) => (Array.isArray(value) ? value : [value]))
  @IsArray()
  @IsEnum(LibraryContentType, { each: true })
  type?: LibraryContentType[]

  @ApiPropertyOptional({ type: 'string', description: 'Filtrer par matière (ID externe)' })
  @IsOptional()
  @IsString()
  subjectId?: string

  @ApiPropertyOptional({ type: 'string', description: 'Filtrer par niveau (ID externe)' })
  @IsOptional()
  @IsString()
  levelId?: string
}

